// USER PREFERENCES INTERACTIVE
document.addEventListener('DOMContentLoaded', function() {
    var userInfoContainer = document.querySelector('.user-info-container');
    var editBtn = document.querySelector('.user-info-edit-btn');
    var cancelBtn = document.querySelector('.user-info-cancel-btn');
    var saveBtn = document.querySelector('.user-info-save-btn');

    // Додає клас "edit" при натисканні на кнопку "Edit"
    editBtn.addEventListener('click', function() {
        userInfoContainer.classList.add('edit');
    });

    // Функція для видалення класу "edit"
    function removeEditClass() {
        userInfoContainer.classList.remove('edit');
    }

    // Видаляє клас "edit" при натисканні на кнопки "Cancel" або "Save"
    cancelBtn.addEventListener('click', removeEditClass);
    saveBtn.addEventListener('click', removeEditClass);
});